module.exports = "<div class=\"searchresults\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/result-box/result-box.component.html
// module id = ./src/app/result-box/result-box.component.html
// module chunks = main